import { GameStatus } from "../../contracts";
export const mapKickOffState = (x) => {
    x.isInKickOffState = x.isLive && x.status === GameStatus.NotStarted;
    return x;
};
//# sourceMappingURL=mapKickOffState.js.map